import { buildEndpoint } from './base.endpoints';

const REPORTS_BASE = '/Reports';
const DASHBOARD_BASE = '/Dashboard';

export const reportEndpoints = {
  employeeActivity: () => buildEndpoint(`${REPORTS_BASE}/employee-activity`),
  employeeActivitySummary: () => buildEndpoint(`${REPORTS_BASE}/employee-activity/summary`),
  wip: () => buildEndpoint(`${REPORTS_BASE}/wip`),
  wipSummary: () => buildEndpoint(`${REPORTS_BASE}/wip/summary`),
  timesheetStatus: () => buildEndpoint(`${REPORTS_BASE}/timesheet-status`),
  // raw paths for buildEndpointWithQuery
  employeeActivityPath: () => `${REPORTS_BASE}/employee-activity`,
  employeeActivitySummaryPath: () => `${REPORTS_BASE}/employee-activity/summary`,
  wipPath: () => `${REPORTS_BASE}/wip`,
  wipSummaryPath: () => `${REPORTS_BASE}/wip/summary`,
  timesheetStatusPath: () => `${REPORTS_BASE}/timesheet-status`,
} as const;

export const dashboardEndpoints = {
  pendingTimesheets: () => buildEndpoint(`${DASHBOARD_BASE}/pending-timesheets`),
  submittedComparison: () => buildEndpoint(`${DASHBOARD_BASE}/submitted-comparison`),
  hoursVsMinimum: () => buildEndpoint(`${DASHBOARD_BASE}/hours-vs-minimum`),
  engagementStatus: () => buildEndpoint(`${DASHBOARD_BASE}/engagement-status`),
  wipSummary: () => buildEndpoint(`${DASHBOARD_BASE}/wip-summary`),
  // raw paths
  pendingTimesheetsPath: () => `${DASHBOARD_BASE}/pending-timesheets`,
  submittedComparisonPath: () => `${DASHBOARD_BASE}/submitted-comparison`,
  hoursVsMinimumPath: () => `${DASHBOARD_BASE}/hours-vs-minimum`,
  engagementStatusPath: () => `${DASHBOARD_BASE}/engagement-status`,
  wipSummaryPath: () => `${DASHBOARD_BASE}/wip-summary`,
} as const;
